import { Button, DateField, Radio, Typography } from "@hellocarbo/lasagne";
import { useContext } from "react";
import { Trans, useTranslation } from "react-i18next";

import { PortalContainerContext } from "@/contexts";
import { TCampaignDuration } from "@/types";
import {
  calculateNextCampaignStartDate,
  formatEndDate,
} from "@/utils/formatDate";

type DateAndDurationProps = {
  prevCampaignEndDate: Date;
  duration: TCampaignDuration;
  onDateChange: (value: Date) => void;
  onDurationChange: (value: TCampaignDuration) => void;
  onButtonClick: () => void;
};

function DateAndDuration({
  prevCampaignEndDate,
  duration,
  onDateChange,
  onDurationChange,
  onButtonClick,
}: DateAndDurationProps) {
  const { t, i18n } = useTranslation(["common", "trackingCampaign"]);
  const { container } = useContext(PortalContainerContext);

  const advicedStartDate = calculateNextCampaignStartDate(prevCampaignEndDate);

  return (
    <>
      <Typography className="mb-lg">
        <Trans
          t={t}
          i18nKey="trackingCampaign:new.description"
          values={{
            prevEndDate: t("formatter:date", {
              value: formatEndDate(prevCampaignEndDate),
            }),
            newStartDate: t("formatter:date", {
              value: advicedStartDate,
            }),
          }}
          components={{
            1: <span className="text-primary font-bold" />,
          }}
        />
      </Typography>
      <div className="gap-y-lg flex flex-col">
        <DateField
          name="startDate"
          language={i18n.language as "fr" | "en"}
          defaultValue={advicedStartDate}
          label={t("trackingCampaign:footprintStartDate")}
          popoverProps={{ portalContainer: container as Element }}
          onChange={onDateChange}
        />
        <Radio
          type="button"
          name="duration"
          defaultValue={duration}
          label={t("trackingCampaign:footprintDuration")}
          items={Object.values(TCampaignDuration).map((duration) => ({
            label: t(`trackingCampaign:durations.${duration}`),
            value: duration,
          }))}
          onValueChange={onDurationChange}
        />
        <div className="text-center">
          <Button onClick={onButtonClick}>{t("common:next")}</Button>
        </div>
      </div>
    </>
  );
}

export default DateAndDuration;
